import { useContext } from "react";
import { ROLE } from "../../../data/enums";
import { AuthenticationContext } from "../../../provider/AuthenticationProvider";
import TabBar, { TabBarProps } from "../../../shared/components/TabBar";
import MaterialOrderListTab from "./MaterialOrderListTab";
import MissingMaterialsTab from "./MissingMaterialsTab";
import OutsourceOrderListTab from "../../OutsourceOrderList/Content";

const Content = ({ onSelectionChange }: { onSelectionChange?: (rows: any[]) => void }) => {
    const {
        user: { role },
    } = useContext(AuthenticationContext);
    const canViewMissingMaterials = [ROLE.MANAGER, ROLE.LOGISTIC_MANAGER, ROLE.PURCHASING_STAFF].includes(role);

    const tabs: TabBarProps[] = [
        {
            label: "Danh sách đơn mua hàng",
            labelEN: "material orders",
            content: <MaterialOrderListTab />,
        },
        {
            label: "Danh sách đơn mua hàng gia công",
            labelEN: "outsource orders",
            content: <OutsourceOrderListTab />,
        },
        ...(canViewMissingMaterials
            ? [
                  {
                      label: "Danh sách vật tư thiếu",
                      labelEN: "missing materials",
                      content: <MissingMaterialsTab onSelectionChange={onSelectionChange} />,
                  },
              ]
            : []),
    ];

    return <TabBar tabs={tabs} />;
};

export default Content;
